import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '../Container';
import ContainerItem from '../ContainerItem';

const useStyles = makeStyles({
  loader: {
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
  },
  loadingText: {
    color: (props: Props): string => props.textColor,
    fontWeight: 'bold',
    fontFamily: 'Open Sans, sans-serif',
    paddingLeft: 10,
  },
  circle: {
    color: (props: Props) => props.spinnerColor,
  },
});

interface Props {
  spinnerColor: string;
  text: string;
  textColor: string;
}

const PlainLoading: React.FC<Props> = ({ text, spinnerColor, textColor }: Props) => {
  const classes = useStyles({ spinnerColor, textColor, text });
  return (
    <Container className={classes.loader}>
      <CircularProgress className={classes.circle} color={'inherit'} />
      <ContainerItem className={classes.loadingText}>{text}</ContainerItem>
    </Container>
  );
};

export default PlainLoading;
